import React from 'react';
import { Provider } from 'react-redux';
import { store, history } from './redux/store';
import { SnackbarProvider } from 'notistack';
import { getTheme } from './settings/themes';
import { MuiThemeProvider } from '@material-ui/core/styles';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import InitRoutes from './router';

function App() {
  return (
    <MuiThemeProvider theme={getTheme()}>
      <Provider store={store} >
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          maxSnack={1}
        >
          <InitRoutes history={history} />
        </SnackbarProvider>
      </Provider>
    </MuiThemeProvider>
  );
}

export default App;
